// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__oJOVD","section":"styles_section__2qXtA","sectionTitleRow":"styles_sectionTitleRow__j0kXd"};